import { render, staticRenderFns } from "./UpdateAgreementTypeDialog.vue?vue&type=template&id=48fc557a&scoped=true&"
import script from "./UpdateAgreementTypeDialog.js?vue&type=script&lang=js&"
export * from "./UpdateAgreementTypeDialog.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fc557a",
  null
  
)

export default component.exports